import { render, staticRenderFns } from "./techExpertises.vue?vue&type=template&id=7077c76c&scoped=true&"
import script from "./techExpertises.vue?vue&type=script&lang=js&"
export * from "./techExpertises.vue?vue&type=script&lang=js&"
import style0 from "./techExpertises.vue?vue&type=style&index=0&id=7077c76c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7077c76c",
  null
  
)

export default component.exports